<app-header [showAvatar]="false" title="Advanced Settings" [useTabs]="true">
  <div id="tabs">
    <reb-ngx-mat-tab-nav-bar [tabs]="tabs"></reb-ngx-mat-tab-nav-bar>
  </div>
</app-header>
<div class="body">
  <router-outlet></router-outlet>
</div>
